import classnames from 'classnames';
import { type FunctionComponent } from 'react';

import { Price } from '@/core/tamagoshi/Price/Price';
import {
  FormatType,
  VatType,
  type CurrencyType,
  type TranslationsType,
} from '@/domains/core/tamagoshi/Price/Price.interfaces';

import { type Tax } from '../../../../interfaces';

import styles from './Retail.module.scss';

export interface RetailProps {
  className?: string;
  currency: CurrencyType;
  tax?: Tax;
  translations?: TranslationsType;
  unit?: string;
  value: number;
}

export const Retail: FunctionComponent<RetailProps> = ({
  className,
  currency,
  translations,
  tax,
  value,
}) => {
  const rootClassnames = classnames(styles.root, className);
  const vatType = tax === 'withoutVAT' ? VatType.EXCLUDED : VatType.INCLUDED;

  return (
    <Price
      value={value}
      className={rootClassnames}
      data-testid="price-retail"
      currency={currency}
      translations={translations}
      vat={tax ? vatType : undefined}
      format={FormatType.TAX_SUP}
    />
  );
};

Retail.displayName = 'Retail';
